import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { actionCleanTranslator } from 'redux/actions/TranslatorActions';
import i18n from "i18next";

function Body(props) {
  let history = useHistory();
  useEffect(() => {
    if (props.oSession.oUser === null)
      history.push('/login');
    if (props.oTranslator.bChange) {
      i18n.changeLanguage(props.oTranslator.sLanguage);
      props.clean();
    }
  })
  return (
    <div className='my-5 my-md-3 mx-md-5'>
      <div className='container-fluid system-body'>
        {props.children}
      </div>
    </div>
  );
}

const mapStateToProps = oState => ({
  oSession: oState.SessionReducer,
  oTranslator: oState.TranslatorReducer,
});

const mapDispatchToProps = dispatch => ({
  clean: () => {
    dispatch(actionCleanTranslator());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Body);
